import * as React from 'react';
import PropTypes from 'prop-types';

const SvgActionsRefreshNormalLarge = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M31 18.58v2.84L41.41 11 31 .58v2.84L38.59 11 31 18.58z"
        fill=""
      />
      <path
        d="M23 46a17 17 0 010-34h8v-2h-9v.02a19 19 0 1010.94 35.17L32 43.41A16.874 16.874 0 0123 46zm10.63-3.76l.96 1.8a18.99 18.99 0 004.72-5.3l-1.77-.95a16.663 16.663 0 01-3.91 4.45zM40 29a16.677 16.677 0 01-1.53 7.02l1.77.94A18.774 18.774 0 0042 29h-2z"
        fill=""
      />
    </svg>
  )
);
SvgActionsRefreshNormalLarge.defaultProps = {
  color: 'currentColor',
  size: 48,
  title: undefined,
  titleId: undefined
};
SvgActionsRefreshNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgActionsRefreshNormalLarge;
